// Migración única al índigo: a quien ya usó el panel le quedaron el dorado y
// el rosa de la plantilla guardados en el navegador. Se sobreescriben una sola
// vez; un color elegido a mano desde el ThemeCustomizer se respeta.
if (localStorage.getItem('default_color') === '#d08f2c') {
  localStorage.setItem('default_color', '#4B36F0');
}
if (localStorage.getItem('secondary_color') === '#f73164') {
  localStorage.setItem('secondary_color', '#3B4266');
}

export class ConfigDB {
  static data = {
    settings: {
      layout_type: 'ltr',
      sidebar: {
        type: 'compact-wrapper',
        iconType: 'stroke-svg',
      },
      sidebar_setting: 'default-sidebar',
    },
    color: {
      primary_color: localStorage.getItem('default_color') || '#4B36F0',
      secondary_color: localStorage.getItem('secondary_color') || '#3B4266',
      mix_background_layout: 'dark-sidebar',
    },
    router_animation: 'fadeIn',
  };
}
export default ConfigDB;
